export const formatters = {
  phone: (value: string) => {
    if (!value) return '';
    // Don't format if the value already contains formatting characters
    if (value.includes('(') || value.includes(')') || value.includes('-') || value.includes(' ')) {
      return value;
    }
    // Only format if we have exactly 10 digits
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    return value;
  },

  ssn: (value: string) => {
    if (!value) return '';
    // Don't format if the value already contains hyphens
    if (value.includes('-')) {
      return value;
    }
    // Only format if we have exactly 9 digits
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length === 9) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`;
    }
    return value;
  },

  currency: (value: string) => {
    if (!value || value === '') return '';
    const num = parseFloat(value);
    if (!isNaN(num) && num >= 0) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(num);
    }
    return value;
  },

  zipcode: (value: string) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length === 9) {
      return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
    }
    return value;
  },

  state: (value: string) => {
    // Always uppercase state codes
    return value.toUpperCase();
  },

  city: (value: string) => {
    // Title case for cities
    if (!value) return '';
    return value.replace(/\b\w/g, char => char.toUpperCase());
  },

  email: (value: string) => value,
  height: (value: string) => value,
  weight: (value: string) => value,
  age: (value: string) => value,
  address: (value: string) => value,
  streetAddress: (value: string) => value,
  ssn4Digit: (value: string) => value,
  npn: (value: string) => {
    if (!value) return '';
    return value.startsWith('NPN: ') ? value : `NPN: ${value}`;
  },
  numberOnly: (value: string) => value,
  driverLicense: (value: string) => {
    if (!value) return '';

    const cleaned = value.replace(/\s/g, '');

    if (cleaned.length <= 4) return cleaned;

    // Insert space every 4 characters for readability
    // e.g., "D12345678" -> "D123 4567 8" or "ABC123456789" -> "ABC1 2345 6789"
    return cleaned.match(/.{1,4}/g)?.join(' ') || cleaned;
  },
  cityStateZipcode: (value: string) => {
    if (!value) return '';
    const parts = value.split(',').map(p => p.trim());
    if (parts.length !== 3) return value;
    const [city, state, zipcode] = parts;
    const formattedCity = city.replace(/\b\w/g, char => char.toUpperCase());
    const formattedState = state.toUpperCase();
    return `${formattedCity}, ${formattedState}, ${zipcode}`;
  },
};
